import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesParcelDetailMain } from './modules/ui/Main';

const ParcelDetailPage = (
  <SuspensePage>
    <PagesParcelDetailMain />
  </SuspensePage>
);

export default ParcelDetailPage;
